import React, { useEffect, useState } from 'react';
import { DateTime } from 'luxon';
import axios from '../../../utils/axiosWithAuth';



const EmailLogs = () => {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalLogs, setTotalLogs] = useState(0);
  const [statusFilter, setStatusFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState(''); // NEW

  const fetchLogs = async () => {
    try {
      const params = {
        page,
        limit: 100,
        ...(statusFilter && { status: statusFilter }),
        ...(dateFilter && { sentAt: dateFilter }),
        ...(typeFilter && { type: typeFilter }), // NEW
      };

      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/email/logs`, { params });


      setLogs(res.data.logs || []);
      setTotalPages(res.data.totalPages || 1);
      setTotalLogs(res.data.totalLogs || 0);
    } catch (err) {
      console.error('Failed to fetch logs:', err);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [page, statusFilter, dateFilter, typeFilter]);

const formatDateTime = (raw) => {
  try {
    return raw
      ? DateTime.fromJSDate(new Date(raw))
          .setZone('Asia/Kolkata')
          .toFormat('dd LLL yyyy, hh:mm a')
      : 'Invalid';
  } catch {
    return 'Invalid';
  }
};



  const getStatusBadge = (status) => {
    const base = 'badge rounded-pill px-2 py-1 text-white';
    switch (status) {
      case 'success':
        return <span className={`${base} bg-success`}>✅ Success</span>;
      case 'failed':
        return <span className={`${base} bg-danger`}>❌ Failed</span>;
      case 'partial':
        return <span className={`${base} bg-warning text-dark`}>⚠️ Partial</span>;
      default:
        return <span className={`${base} bg-secondary`}>Unknown</span>;
    }
  };

  return (
    <div className="container mt-4">
      <h3>📨 Email Logs (Mail-wise)</h3>
      <p className="text-muted">Total Logs: {totalLogs}</p>

      {/* Filters */}
      <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
        <div>
          <label className="form-label mb-1">📊 Status</label>
          <select
            className="form-select"
            value={statusFilter}
            onChange={(e) => {
              setPage(1);
              setStatusFilter(e.target.value);
            }}
          >
            <option value="">All</option>
            <option value="success">✅ Success</option>
            <option value="failed">❌ Failed</option>
            <option value="partial">⚠️ Partial</option>
          </select>
        </div>

        <div>
          <label className="form-label mb-1">📅 Sent At</label>
          <input
            type="date"
            className="form-control"
            value={dateFilter}
            onChange={(e) => {
              setPage(1);
              setDateFilter(e.target.value);
            }}
          />
        </div>

        <div>
          <label className="form-label mb-1">⚙️ Type</label>
          <select
            className="form-select"
            value={typeFilter}
            onChange={(e) => {
              setPage(1);
              setTypeFilter(e.target.value);
            }}
          >
            <option value="">All</option>
            <option value="auto">Auto</option>
            <option value="manual">Manual</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-light">
            <tr>
              <th>📅 Sent At</th>
              <th>📝 Subject</th>
              <th>⚙️ Type</th>
              <th>📊 Status</th>
              <th>📬 Total</th>
              <th>✅ Success</th>
              <th>❌ Failed</th>
            </tr>
          </thead>
          <tbody>
            {logs.length > 0 ? (
              logs.map((log) => (
                <tr key={log._id}>
                  <td>{formatDateTime(log.sentAt)}</td>
                  <td>{log.subject}</td>
                  <td>{log.type}</td>
                  <td>{getStatusBadge(log.status)}</td>
                  <td>{log.total}</td>
                  <td>{log.success}</td>
                  <td>{log.failed}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center text-muted py-4">
                  No logs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-3">
          <button
            className="btn btn-outline-secondary"
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            ⬅ Prev
          </button>
          <span className="fw-bold">
            Page {page} of {totalPages}
          </span>
          <button
            className="btn btn-outline-secondary"
            disabled={page === totalPages}
            onClick={() => setPage((prev) => prev + 1)}
          >
            Next ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default EmailLogs;
